import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BRAND, NAV_LINKS } from "@/data/content";
import { useEnroll } from "@/context/EnrollContext";

export const Footer = () => {
  const { openEnroll } = useEnroll();
  const socials = [
    { Icon: Instagram, href: "https://www.instagram.com/changeurstory.in/", label: "Instagram" },
    { Icon: Facebook, href: "https://www.facebook.com/ChangeUrStory.in/", label: "Facebook" },
    { Icon: Youtube, href: "https://www.youtube.com/user/Chinmayeeabbey", label: "YouTube" },
    { Icon: Linkedin, href: "https://www.linkedin.com/company/changeurstory/", label: "LinkedIn" },
  ];

  return (
    <footer className="bg-[#111827]">
      {/* Main footer */}
      <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-[2fr_1fr_1fr_1fr]">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block">
              <img
                src="/image/logo3.png"
                alt="Change Ur Story Logo"
                className="h-20 sm:h-24 w-auto object-contain"
              />
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/50">
              Meet CHINI, your Hybrid AI Interview Coach for realistic practice, personalized guidance, and greater confidence in every interview.
            </p>
            {/* Socials */}
            <div className="mt-6 flex gap-3">
              {socials.map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 text-white/50 transition-colors hover:border-primary/50 hover:text-primary"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Explore */}
          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wide text-white">Explore</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-white/50 transition-colors hover:text-white">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wide text-white">Resources</h4>
            <ul className="mt-5 space-y-3">
              {["Blog", "Webinars", "Career Tips", "Resume Templates", "Salary Guide"].map((item) => (
                <li key={item}>
                  <a href="#" className="text-sm text-white/50 transition-colors hover:text-white">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wide text-white">Get in Touch</h4>
            <ul className="mt-5 space-y-3 text-sm text-white/50">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-primary shrink-0" />
                contact@changeurstory.in
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-primary shrink-0" />
                +91 98106 02955
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-primary shrink-0 mt-0.5" />
                Sec-36, Noida, India
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-7 sm:flex-row">
          <p className="text-xs text-white/30">© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
          <div className="flex gap-5 text-xs text-white/30">
            <a href="#" className="hover:text-white/60 transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white/60 transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-white/60 transition-colors">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
